
















































































import mixins from 'vue-typed-mixins';
import Vue from 'vue';
import VatsAPI from '@/Shared/VatsAPI';
import Permit from '@/Permit/Permit';
import LocationLookupDropdown from '@/Shared/LocationLookupDropdown.vue';
import { PermitRequestStatus } from '@/Permit/Enum';
import PermitVariables from '@/Permit/PermitVariables';
import { User } from '@/Stores/UserStore';
import UserMixin from '@/Shared/UserMixin';

export default mixins(UserMixin).extend({
  name: 'PermitSearch',
  props: {
      location: {
          required: true,
          type: '' as any as () => string
      },
      permitID: {
          required: false,
          type: '' as any as () => string
      },
      vehicleLicense: {
          required: false,
          type: '' as any as () => string
      },
      settings: {
          required: true,
          type: Object as () => PermitVariables
      }
  },
  components: {
     LocationLookupDropdown
  },
  async mounted() {
    await this.loadUser();
    this.searchParams.recID = this.permitID ?? '';
    this.searchParams.vehicleLicense = this.vehicleLicense ?? '';

    if (this.searchParams.recID) {
      this.search('id');
    }
  },
  data() {
      return {
        searchParams: {} as any,
        selectedPermit: {} as Permit,
        foundPermits: [] as Permit[],
        showNotFoundMessage: false,
        renewablePermits: {} as {[recID: string]: boolean},
        i18nPrefix: 'permits.permitSearch'
      };
  },
  computed: {
    plateSearchEndpoint(): string {
      const method = 'permitsByPlate' + (this.isInternal ? 'Internal' : '');

      return `/${this.location}/Permits/${method}`;
    },
    idSearchEndpoint(): string {
      const method = 'permitById' + (this.isInternal ? 'Internal' : '');

      return `/${this.location}/Permits/${method}`;
    }
  },
  methods: {
      payable(permit: Permit): boolean {
        return (this.settings.payAfterApproval && permit.requestStatus === PermitRequestStatus.APPROVED)
          || (!this.settings.payAfterApproval && permit.requestStatus === PermitRequestStatus.APPLIED);
      },
      getCustomerName(permit: Permit) {
          if (permit.customer) {
              return `${permit.customer.firstName}  ${permit.customer.lastName}`;
          }
          else {
              return '';
          }
      },
      selectPermit(permit: Permit) {
        this.selectedPermit = permit;
        this.$emit('permitSelected', this.selectedPermit);
      },
      async checkRenewable(permit: Permit) {
        return VatsAPI.get<boolean>(`/${this.location}/Permits/renewable`, { params: { recID: permit.recID }})
          .then(response => {
            this.renewablePermits = {...this.renewablePermits, [permit.recID]: response.data };
          });
      },
      async search(by: string) {
        this.showNotFoundMessage = false;
        this.foundPermits = [] as Permit[];
        this.selectedPermit = {} as Permit;
        this.renewablePermits = {} as {[recID: string]: boolean};

        try {
            const result = by === 'plate' ?
                (await VatsAPI.get<Permit[]>(this.plateSearchEndpoint,
                    {
                        params: {
                            vehicleLicense: this.searchParams.vehicleLicense,
                            plateState: this.searchParams.plateState
                    }})
                ).data :
                [(await VatsAPI.get<Permit>(this.idSearchEndpoint,
                    { params: {
                        recID: this.searchParams.recID
                    }})).data];

            this.foundPermits = result;
        }
        catch (e) {
            this.foundPermits = [] as Permit[];
        }

        if (!this.foundPermits.length) {
            this.showNotFoundMessage = true;
            this.$emit('permitNotFound');
        }
        else {
          const requests = this.foundPermits.map(permit => this.checkRenewable(permit));

          await Promise.all(requests);
        }
      }
  }
});
